import type { ReactNode } from 'react';
import { COPY } from '@/shared/content/copy';
import styles from './ls-panel.module.scss';

/**
 * Вид панели.
 *
 * `sheet` — окно, приходящее снизу: скруглено только сверху, высота
 * по содержимому. Отдельный вид, а не ящик во всю высоту: ящик корзины
 * занимает экран целиком, и шесть строк размеров в нём потерялись бы.
 */
type Tone = 'window' | 'drawer' | 'sheet';

interface Props {
  title: string;
  tone?: Tone;
  onClose?: () => void;
  footer?: ReactNode;
  children: ReactNode;
}

/** Оформление содержимого всплывающего слоя: заголовок, крестик, подвал. */
export function LsPanel({ title, tone = 'window', onClose, footer, children }: Props) {
  return (
    <section className={`${styles['ls-panel']} ${styles[`ls-panel--${tone}`]}`}>
      <header className={styles['ls-panel__head']}>
        <h2 className={styles['ls-panel__title']}>{title}</h2>

        {onClose && (
          <button
            className={styles['ls-panel__close']}
            type="button"
            onClick={onClose}
            aria-label={COPY.cart.close}
          >
            <span className={styles['ls-panel__close-icon']} />
          </button>
        )}
      </header>

      <div className={styles['ls-panel__body']}>{children}</div>

      {footer && <footer className={styles['ls-panel__foot']}>{footer}</footer>}
    </section>
  );
}
